import InquiryContainer from '@/containers/InquiryContainer';
import { LayoutTableContainer } from '../orders/_layouts/LayoutTableContainer';
import { LayoutReviewContainer, LayoutReviewsBody } from '../orders/_layouts/LayoutsReviews';
import { useState } from 'react';

import { Button } from '@/components/atoms/NewPcButton';
import InquiryHistoryPage from '../InquiryHistoryPage';
import { useSearchParams } from 'react-router-dom';
import { useEffect } from 'react';
const SupportContainer = () => {
  const [selectHistory, setSelectHistory] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (searchParams.get('chistory') === 'true') {
      setSelectHistory(true);

      // 파라미터 제거 (다른 파라미터가 있으면 보존)
      const newParams = new URLSearchParams(searchParams);
      newParams.delete('chistory');
      setSearchParams(newParams, { replace: true }); // replace: true로 히스토리 쌓이지 않게
    }
  }, [searchParams, setSearchParams]);

  return (
    <LayoutTableContainer>
      <LayoutReviewContainer>
        <LayoutReviewsBody className="">
          {!selectHistory ? (
            <>
              <div className="flex h-full w-full flex-col items-start justify-start gap-[20px]   py-[20px]">
                <div className="flex w-full justify-between">
                  <div className="text-gr-600 Body5M14">
                    문의내용은 업무시간 내에 최대한 답변드려요! <br />
                    오류 등으로 저희가 보완할 부분이 있으면 답변이 지연될 수 있어요. [고객센터 운영
                    시간 - 평일 10:00 ~ 18:00]
                  </div>
                  <div>
                    <Button
                      size={'small'}
                      variant="line"
                      onClick={() => setSelectHistory(true)}
                      className="w-fit text-gr-700 shadow-none Body5M14"
                    >
                      문의내역 보기
                    </Button>
                  </div>
                </div>
                <div className="flex w-full  flex-col gap-[16px] ">
                  <InquiryContainer setSelectHistory={setSelectHistory} />
                </div>
              </div>
            </>
          ) : (
            <InquiryHistoryPage setSelectHistory={setSelectHistory} />
          )}
        </LayoutReviewsBody>
      </LayoutReviewContainer>
    </LayoutTableContainer>
  );
};

export default SupportContainer;
